// Get Product List
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";

///productselfservewidget/render/:id
export const GET_PRODUCT_SELF_SERVE_WIDGET_RENDER = "GET_PRODUCT_SELF_SERVE_WIDGET_RENDER";
export const GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS = "GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS";
export const GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE = "GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE";
///productselfserve/public/book/:id
export const POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK = "POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK";
export const POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS = "POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS";
export const POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE = "POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE";
///productselfservewidget/checkavailability/:id
export const POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY = "POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY";
export const POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS = "POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS";
export const POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE = "POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE";
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS";
export const GET_PRODUCT_LIST_FAILURE = "GET_PRODUCT_LIST_FAILURE";

export const GET_PRODUCT_LIST_NEW_API_CALL = "GET_PRODUCT_LIST_NEW_API_CALL";
export const GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS =
  "GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS";
export const GET_PRODUCT_LIST_NEW_API_CALL_FAILURE =
  "GET_PRODUCT_LIST_NEW_API_CALL_FAILURE";

// Get Product Detail
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS";
export const GET_PRODUCT_DETAIL_FAILURE = "GET_PRODUCT_DETAIL_FAILURE";

// Add Product
export const ADD_PRODUCT = "ADD_PRODUCT";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

// Update Product
export const UPDATE_PRODUCT_CRM = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_SUCCESS_CRM = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE_CRM = "UPDATE_PRODUCT_FAILURE";

// Delete Product
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

// Search products allowed time tracking
export const SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING =
  "SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING";
export const SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS =
  "SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS";
export const SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE =
  "SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE";

///productpricing/search
export const SEARCH_PRODUCTS_PRICING = "SEARCH_PRODUCTS_PRICING";
export const SEARCH_PRODUCTS_PRICING_SUCCESS =
  "SEARCH_PRODUCTS_PRICING_SUCCESS";
export const SEARCH_PRODUCTS_PRICING_FAILURE =
  "SEARCH_PRODUCTS_PRICING_FAILURE";
///productpricing/create
export const CREATE_PRODUCTS_PRICING = "CREATE_PRODUCTS_PRICING";
export const CREATE_PRODUCTS_PRICING_SUCCESS =
  "CREATE_PRODUCTS_PRICING_SUCCESS";
export const CREATE_PRODUCTS_PRICING_FAILURE =
  "CREATE_PRODUCTS_PRICING_FAILURE";
///productpricing/update
export const UPDATE_PRODUCTS_PRICING = "UPDATE_PRODUCTS_PRICING";
export const UPDATE_PRODUCTS_PRICING_SUCCESS =
  "UPDATE_PRODUCTS_PRICING_SUCCESS";
export const UPDATE_PRODUCTS_PRICING_FAILURE =
  "UPDATE_PRODUCTS_PRICING_FAILURE";
///productpricing/delete
export const DELETE_PRODUCTS_PRICING = "DELETE_PRODUCTS_PRICING";
export const DELETE_PRODUCTS_PRICING_SUCCESS =
  "DELETE_PRODUCTS_PRICING_SUCCESS";
export const DELETE_PRODUCTS_PRICING_FAILURE =
  "DELETE_PRODUCTS_PRICING_FAILURE";

// Task 24858 - ProductPrice, the product's own dated price schedule. Distinct
// from PRODUCTS_PRICING above, which is a customer's bespoke price.
export const SEARCH_PRODUCT_PRICE = "SEARCH_PRODUCT_PRICE";
export const SEARCH_PRODUCT_PRICE_SUCCESS = "SEARCH_PRODUCT_PRICE_SUCCESS";
export const SEARCH_PRODUCT_PRICE_FAILURE = "SEARCH_PRODUCT_PRICE_FAILURE";

export const CREATE_PRODUCT_PRICE = "CREATE_PRODUCT_PRICE";
export const CREATE_PRODUCT_PRICE_SUCCESS = "CREATE_PRODUCT_PRICE_SUCCESS";
export const CREATE_PRODUCT_PRICE_FAILURE = "CREATE_PRODUCT_PRICE_FAILURE";

export const UPDATE_PRODUCT_PRICE = "UPDATE_PRODUCT_PRICE";
export const UPDATE_PRODUCT_PRICE_SUCCESS = "UPDATE_PRODUCT_PRICE_SUCCESS";
export const UPDATE_PRODUCT_PRICE_FAILURE = "UPDATE_PRODUCT_PRICE_FAILURE";

export const DELETE_PRODUCT_PRICE = "DELETE_PRODUCT_PRICE";
export const DELETE_PRODUCT_PRICE_SUCCESS = "DELETE_PRODUCT_PRICE_SUCCESS";
export const DELETE_PRODUCT_PRICE_FAILURE = "DELETE_PRODUCT_PRICE_FAILURE";
///productpricing/data
export const GET_PRODUCTS_PRICING_DATA = "GET_PRODUCTS_PRICING_DATA";
export const GET_PRODUCTS_PRICING_DATA_SUCCESS =
  "GET_PRODUCTS_PRICING_DATA_SUCCESS";
export const GET_PRODUCTS_PRICING_DATA_FAILURE =
  "GET_PRODUCTS_PRICING_DATA_FAILURE";
///productrecentactivity/list
export const GET_PRODUCTS_RECENT_ACTIVITY = "GET_PRODUCTS_RECENT_ACTIVITY";
export const GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS =
  "GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS";
export const GET_PRODUCTS_RECENT_ACTIVITY_FAILURE =
  "GET_PRODUCTS_RECENT_ACTIVITY_FAILURE";
///productpricing/list
export const GET_PRODUCTS_PRICING_LIST = "GET_PRODUCTS_PRICING_LIST";
export const GET_PRODUCTS_PRICING_LIST_SUCCESS =
  "GET_PRODUCTS_PRICING_LIST_SUCCESS";
export const GET_PRODUCTS_PRICING_LIST_FAILURE = "GET_PRODUCTS_PRICING_LIST_FAILURE";
//foodallergen/list
export const GET_FOOD_ALLERGEN_LIST = "GET_FOOD_ALLERGEN_LIST";
export const GET_FOOD_ALLERGEN_LIST_SUCCESS = "GET_FOOD_ALLERGEN_LIST_SUCCESS";
export const GET_FOOD_ALLERGEN_LIST_FAILURE = "GET_FOOD_ALLERGEN_LIST_FAILURE";
///foodallergen/data
export const GET_FOOD_ALLERGEN_DATA = "GET_FOOD_ALLERGEN_DATA";
export const GET_FOOD_ALLERGEN_DATA_SUCCESS = "GET_FOOD_ALLERGEN_DATA_SUCCESS";
export const GET_FOOD_ALLERGEN_DATA_FAILURE = "GET_FOOD_ALLERGEN_DATA_FAILURE";
///foodallergen/create
export const CREATE_FOOD_ALLERGEN = "CREATE_FOOD_ALLERGEN";
export const CREATE_FOOD_ALLERGEN_SUCCESS = "CREATE_FOOD_ALLERGEN_SUCCESS";
export const CREATE_FOOD_ALLERGEN_FAILURE = "CREATE_FOOD_ALLERGEN_FAILURE";
///foodallergen/update
export const UPDATE_FOOD_ALLERGEN = "UPDATE_FOOD_ALLERGEN";
export const UPDATE_FOOD_ALLERGEN_SUCCESS = "UPDATE_FOOD_ALLERGEN_SUCCESS";
export const UPDATE_FOOD_ALLERGEN_FAILURE = "UPDATE_FOOD_ALLERGEN_FAILURE";
///foodallergen/delete
export const DELETE_FOOD_ALLERGEN = "DELETE_FOOD_ALLERGEN";
export const DELETE_FOOD_ALLERGEN_SUCCESS = "DELETE_FOOD_ALLERGEN_SUCCESS";
export const DELETE_FOOD_ALLERGEN_FAILURE = "DELETE_FOOD_ALLERGEN_FAILURE";
// Food Diet Type
export const GET_FOOD_DIET_TYPE_LIST = "GET_FOOD_DIET_TYPE_LIST";
export const GET_FOOD_DIET_TYPE_LIST_SUCCESS = "GET_FOOD_DIET_TYPE_LIST_SUCCESS";
export const GET_FOOD_DIET_TYPE_LIST_FAILURE = "GET_FOOD_DIET_TYPE_LIST_FAILURE";

///fooddiettype/data
export const GET_FOOD_DIET_TYPE_DATA = "GET_FOOD_DIET_TYPE_DATA";
export const GET_FOOD_DIET_TYPE_DATA_SUCCESS = "GET_FOOD_DIET_TYPE_DATA_SUCCESS";
export const GET_FOOD_DIET_TYPE_DATA_FAILURE = "GET_FOOD_DIET_TYPE_DATA_FAILURE";

///fooddiettype/create
export const CREATE_FOOD_DIET_TYPE = "CREATE_FOOD_DIET_TYPE";
export const CREATE_FOOD_DIET_TYPE_SUCCESS = "CREATE_FOOD_DIET_TYPE_SUCCESS";
export const CREATE_FOOD_DIET_TYPE_FAILURE = "CREATE_FOOD_DIET_TYPE_FAILURE";

///fooddiettype/update
export const UPDATE_FOOD_DIET_TYPE = "UPDATE_FOOD_DIET_TYPE";
export const UPDATE_FOOD_DIET_TYPE_SUCCESS = "UPDATE_FOOD_DIET_TYPE_SUCCESS";
export const UPDATE_FOOD_DIET_TYPE_FAILURE = "UPDATE_FOOD_DIET_TYPE_FAILURE";

///fooddiettype/delete
export const DELETE_FOOD_DIET_TYPE = "DELETE_FOOD_DIET_TYPE";
export const DELETE_FOOD_DIET_TYPE_SUCCESS = "DELETE_FOOD_DIET_TYPE_SUCCESS";
export const DELETE_FOOD_DIET_TYPE_FAILURE = "DELETE_FOOD_DIET_TYPE_FAILURE";

///productattribute/list
export const GET_PRODUCT_ATTRIBUTE_LIST = "GET_PRODUCT_ATTRIBUTE_LIST";
export const GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS = "GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_LIST_FAILURE = "GET_PRODUCT_ATTRIBUTE_LIST_FAILURE";

///productattribute/data
export const GET_PRODUCT_ATTRIBUTE_DATA = "GET_PRODUCT_ATTRIBUTE_DATA";
export const GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS = "GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_DATA_FAILURE = "GET_PRODUCT_ATTRIBUTE_DATA_FAILURE";

///productattribute/create
export const CREATE_PRODUCT_ATTRIBUTE = "CREATE_PRODUCT_ATTRIBUTE";
export const CREATE_PRODUCT_ATTRIBUTE_SUCCESS = "CREATE_PRODUCT_ATTRIBUTE_SUCCESS";
export const CREATE_PRODUCT_ATTRIBUTE_FAILURE = "CREATE_PRODUCT_ATTRIBUTE_FAILURE";

///productattribute/update
export const UPDATE_PRODUCT_ATTRIBUTE = "UPDATE_PRODUCT_ATTRIBUTE";
export const UPDATE_PRODUCT_ATTRIBUTE_SUCCESS = "UPDATE_PRODUCT_ATTRIBUTE_SUCCESS";
export const UPDATE_PRODUCT_ATTRIBUTE_FAILURE = "UPDATE_PRODUCT_ATTRIBUTE_FAILURE";

///productattribute/delete
export const DELETE_PRODUCT_ATTRIBUTE = "DELETE_PRODUCT_ATTRIBUTE";
export const DELETE_PRODUCT_ATTRIBUTE_SUCCESS = "DELETE_PRODUCT_ATTRIBUTE_SUCCESS";
export const DELETE_PRODUCT_ATTRIBUTE_FAILURE = "DELETE_PRODUCT_ATTRIBUTE_FAILURE";

///productattributevalue/list
export const GET_PRODUCT_ATTRIBUTE_VALUE_LIST = "GET_PRODUCT_ATTRIBUTE_VALUE_LIST";
export const GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS = "GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE = "GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE";

///productattributevalue/data
export const GET_PRODUCT_ATTRIBUTE_VALUE_DATA = "GET_PRODUCT_ATTRIBUTE_VALUE_DATA";
export const GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS = "GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE = "GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE";

///productattributevalue/create
export const CREATE_PRODUCT_ATTRIBUTE_VALUE = "CREATE_PRODUCT_ATTRIBUTE_VALUE";
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS = "CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS";
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE = "CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE";

///productattributevalue/update
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE = "UPDATE_PRODUCT_ATTRIBUTE_VALUE";
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS = "UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS";
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE = "UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE";

///productattributevalue/delete
export const DELETE_PRODUCT_ATTRIBUTE_VALUE = "DELETE_PRODUCT_ATTRIBUTE_VALUE";
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS = "DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS";
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE = "DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE";

///productattributevalueprice/list
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST";
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE";

///productattributevalueprice/data
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA";
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS";
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE = "GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE";

///productattributevalueprice/create
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE = "CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE";
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS = "CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS";
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE = "CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE";

///productattributevalueprice/update
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE = "UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE";
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS = "UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS";
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE = "UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE";

///productattributevalueprice/delete
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE = "DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE";
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS = "DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS";
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE = "DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE";
